module.exports = __webpack_public_path__ + "img/g-t1.a6bbebae.png";